import Popover from 'bootstrap/js/dist/popover.js'

const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')

/* eslint-disable no-unused-vars */
const popoverList = [...popoverTriggerList].map((popoverTriggerEl) => new Popover(popoverTriggerEl))
/* eslint-enable no-unused-vars */
